import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    const scrollToPosition = () => {
      if (location.hash) {
        const id = location.hash.slice(1);
        const target = document.getElementById(id);
        if (target) {
          const headerOffset = 96;
          const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerOffset;
          window.scrollTo({ top: targetPosition, behavior: "smooth" });
          return;
        }
      }

      window.scrollTo({ top: 0, behavior: "auto" });
    };

    const timer = window.setTimeout(scrollToPosition, 50);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
